import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { _get, _post } from "../../Utils/Helper";
import { toast } from "react-toastify";
import MultiSelect, { Option } from "../../../core/common/multiSelect";
import CommonSelect from "../../../core/common/commonSelect";
import { teacher } from "../../../core/common/selectoption/selectoption";

interface SubjectOption {
    label: string;
    value: string;
    section: string;
}
const AutomateTimeTable = () => {
    const { teacher_roles } = useSelector((state: any) => state.auth);
    const { user } = useSelector((state: RootState) => state.auth);
    const [selectedSubjects, setSelectedSubjects] = useState<SubjectOption[]>([]);
    const [selectedSection, setSelectedSection] = useState("");
    const [selectedClasses, setSelectedClasses] = useState<Option[]>([]);
    const [selectedTimeSlots, setSelectedTimeSlots] = useState<Option[]>([]);
    const [subjects, setSubjects] = useState<SubjectOption[]>([]);
    const [loading, setLoading] = useState(false);

    // Time Slot Options
    const timeSlotOptions: Option[] = [
        {
            label: "08:00 AM - 08:45 AM",
            value: "08:00 AM - 08:45 AM"
        },
        {
            label: "08:45 AM - 09:30 AM",
            value: "08:45 AM - 09:30 AM"
        },
        {
            label: "09:30 AM - 10:15 AM",
            value: "09:30 AM - 10:15 AM"
        },
        {
            label: "10:15 AM - 11:00 AM",
            value: "10:15 AM - 11:00 AM"
        },
        {
            label: "11:00 AM - 11:45 AM",
            value: "11:00 AM - 11:45 AM"
        },
        {
            label: "11:45 AM - 12:30 PM",
            value: "11:45 AM - 12:30 PM"
        },
        {
            label: "12:30 PM - 01:15 PM",
            value: "12:30 PM - 01:15 PM"
        },
        {
            label: "01:15 PM - 01:45 PM",
            value: "01:15 PM - 01:45 PM"
        }
    ];

    const filteredSubjects = selectedSection.length ?
        subjects?.filter((item: any) => item.section === selectedSection).map((item: any) => ({
            label: item.label,
            value: item.value,
            section: item.section
        })) : subjects.map((item: any) => ({
            label: item.label,
            value: item.value,
            section: item.section
        }))
    // Get class options from teacher roles
    const classOptions = selectedSection.length ?
        teacher_roles?.filter((item: any) => item.section === selectedSection).map((item: any) => ({
            label: item.class_name,
            value: item.class_name,
        }))
        : teacher_roles?.map((item: any) => ({
            label: item.class_name,
            value: item.class_name,
        })) || [];

    // Get unique sections
    const sections = Array.from(new Set(teacher_roles.map((cls: any) => cls.section)))
        .map((section: any) => ({
            label: section,
            value: section,
        }));

    // Fetch subjects
    useEffect(() => {
        _get(
            "subjects?query_type=select-all",
            (res) => {
                if (res.success && res.data && res.data.length) {
                    setSubjects(res.data.map((subject: any) => ({
                        label: subject.subject,
                        value: subject.subject,
                        section: subject.section,
                    })));
                }
            },
            (err) => console.log(err)
        );
    }, []);

    const handleGenerateTimetable = async () => {
        if (!selectedSubjects.length || !selectedSection || !selectedClasses.length || !selectedTimeSlots.length) {
            toast.error("Please select at least one subject, section, class, and time slot");
            return;
        }

        const payload = {
            school_id: user.school_id,
            subjects: selectedSubjects.map(s => ({ subject: s.value, section: selectedSection, teacher_id: user.id })),
            section: selectedSection,
            classes: selectedClasses.map(c => c.value),
            timeSlots: selectedTimeSlots.map(t => t.value)
        };

        setLoading(true);
        _post('generate-timetable', payload, response => {
            if (response?.success) {
                toast.success("Timetable generated successfully!");
                // Handle successful generation (e.g., redirect or refresh data)
            } else {
                toast.error(response.message || "Generation failed");
            }
        }, (error) => {
            toast.error("An error occurred during generation");
        });
    };

    return (
        <div className="page-wrapper">
            <div className="content content-two">
                {/* {JSON.stringify(subjects)} */}
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">Automate Timetable Generation  {selectedSection?`For (${selectedSection}) Section`:""}</h4>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="mb-3">
                                    <label className="form-label">Select Sections</label>
                                    <CommonSelect
                                        options={sections}
                                        defaultValue={{
                                            label: selectedSection || "",
                                            value: selectedSection || "",
                                        }}
                                        handleChange={(newValue) => setSelectedSection(newValue?.value || "")}
                                    />
                                </div>
                            </div>
                            {/* {JSON.stringify(selectedSubjects)} */}
                            <div className="col-md-3">
                                <div className="mb-3">
                                    <label className="form-label">Select Subjects</label>
                                    <MultiSelect
                                        options={filteredSubjects}
                                        defaultValue={selectedSubjects}
                                        handleChange={(newValue) => setSelectedSubjects(newValue as SubjectOption[])}
                                    />
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="mb-3">
                                    <label className="form-label">Select Classes</label>
                                    <MultiSelect
                                        options={classOptions}
                                        defaultValue={selectedClasses}
                                        handleChange={(newValue) => setSelectedClasses(newValue as Option[])}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="mb-3">
                                    <label className="form-label">Select Time Slots</label>
                                    <MultiSelect
                                        options={timeSlotOptions}
                                        defaultValue={selectedTimeSlots}
                                        handleChange={(newValue) => setSelectedTimeSlots(newValue as Option[])}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="text-end">
                            <button
                                className="btn btn-primary"
                                onClick={handleGenerateTimetable}
                                disabled={loading}
                            >
                                {loading ? 'Generating...' : 'Generate Timetable'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AutomateTimeTable;
